define(['require', 'angular', '../module'], function(require, angular, MODULE_NAME) {
    'use strict';

    angular.module(MODULE_NAME)
        .service('$ilmnUiAlertBannerService', UiAlertBannerService);

    UiAlertBannerService.$inject = ['$compile', '$rootScope'];
    function UiAlertBannerService($compile, $rootScope) {
        this.compile = $compile;
        this.scope = $rootScope;
        this.banners = [];
        this.modalBannerCount = 0;
    }

    UiAlertBannerService.prototype.show = function(options) {
        options = options || {};

        var svc = this;
        var parentEl = angular.element(options.prependTo || 'body');
        var banner = angular.element('<ilmn-ui-alert-banner options="options"></ilmn-ui-alert-banner>');
        var childScope = (options.scope || this.scope).$new();
        var bannerIdx = this.banners.length;

        angular.extend(childScope, {options: options, close: function() {
            svc.closeBanner(bannerIdx, options);
        }});

        var el = this.compile( banner )(childScope);

        if(options.overlay === true) {
            this.modalBannerCount++;
            this.showOverlay(parentEl);
            this.disableAllEvents(el);
        }

        this.banners.push(el);
        parentEl.prepend(el);

        return childScope;
    };

    UiAlertBannerService.prototype.closeBanner = function(bannerIdx, bannerOptions) {
        this.banners[bannerIdx].remove();

        if(bannerOptions.overlay === true) {
            this.modalBannerCount--;

            if(this.modalBannerCount === 0) {
                this.overlay.detach();
            }
        }
        
        if(typeof bannerOptions.onClose === 'function') {
            bannerOptions.onClose();
        }
    };

    UiAlertBannerService.prototype.clearBanners = function() {
        this.banners.forEach(function(banner) {
            banner.remove();
        });
        if(this.overlay) {
            this.overlay.detach();
        }
    };

    UiAlertBannerService.prototype.showOverlay = function(container) {
        if(!this.overlay) {
            this.overlay = angular.element('<div class="ilmn-alert-banner__overlay"></div>');
            this.disableAllEvents(this.overlay);
        }

        container.prepend(this.overlay);
    };

    UiAlertBannerService.prototype.disableAllEvents = function(el) {
        el.on("mousemove keydown DOMMouseScroll mousewheel mousedown touchstart touchmove scroll", function(event) {
            event.stopPropagation();
        })
    };
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-alert-banner/scripts/alertBanner.service.js
// module id = 40
// module chunks = 0